export default {
  VALIDATE: 'VALIDATE',
  BUSINESS: 'Business',
  EXCEPTION: 'Exception',
};
